import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postDocumento, getAllDocumentos } from "../../../redux/documentos/documentosAction";
import { getAllClientes } from "../../../redux/clientes/clientesAction";
import ClienteInput from "./clienteInput";
import ArticulosInput from "./articulosInput";
import OtrosArticulos from "./otrosArticulos";
import DocumentoPDF from "./documentoPDF";
import '../../../index.css';
import Select from 'react-select';

export default function DocumentoNuevo(){
    const dispatch = useDispatch();
    const clienteInputRef = useRef(null);
    const documentos = useSelector(state => state.documentos.allDocumentos)
    const [numDocumento, setNumDocumento] = useState(0);
    const [clienteRegular, setClienteRegular] = useState(false);
    const [clienteData, setClienteData] = useState({});
    const [articuloData, setArticuloData] = useState([
        {codArticulo: "", nombre:"", ciclo:"", isbn:"", cantidad:"", precio:"", precioTotal:""}        //id: crypto.randomUUID(), 
    ])
    const [subTotal, setSubTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [cantidadArt, setCantidadArt] = useState(0);
    const [artRepetido, setArtRepetido] = useState(false);    
    const [clienteError, setClienteError] = useState(false);
    const [articuloError, setArticuloError] = useState(false);
    const [verPDF, setVerPDF] = useState(false);
    const [otrasEditoriales, setOtrasEditoriales] = useState(true);
   

    useEffect(() => {
        dispatch(getAllDocumentos())
    }, []);

    useEffect(() => {
        dispatch(getAllClientes())
    }, []);

    useEffect(() => {
        sumaSubtotal();
        handleTotal();       
    }, [articuloData, subTotal]);

    useEffect(() => {
        nuevoInput();
    }, [articuloData]);

    useEffect(() => {
        handleCantidadArt();        
    }, [articuloData]);

    
    //console.log("Documentos", documentos);
    //console.log("ClienteData", clienteData);

    useEffect(() => {
                handleNumDoc();
    }, [documentos]);
    
    const handleNumDoc = () => {
        const numDoc = documentos[1] + 1;
        setNumDocumento(numDoc);
        //console.log(numDoc);
    }

    const handleClienteChange = (data) => {
        console.log(data);
        setClienteData(data)
    }
   
    const handleArticuloChange = (index, updatedArticulo) => {
        console.log("index", index);
        console.log("update", updatedArticulo);  

        //if(articuloData.length < 31){
        if(otrasEditoriales){
            const articuloRepeat = articuloData.find((e, i) => e.id === updatedArticulo.id && i != index);
            console.log("articuloRepeat", articuloRepeat);
            if(articuloRepeat){
                setArtRepetido(true);
                return;
            }       
            
            const newArticulos = [...articuloData];
            console.log(newArticulos[index]);
            
            newArticulos[index] = updatedArticulo;
            setArticuloData(newArticulos);
                // } else { 
                //     setMaximo30(true) 
                // } 
        } else {
            const newArticulos = [...articuloData];
            console.log(newArticulos[index]);
            
            newArticulos[index] = updatedArticulo;
            setArticuloData(newArticulos);
                // } else { 
                //     setMaximo30(true) 
                // } 
        }
      };

      const nuevoInput = () => {
        //console.log("checkAndAddNewArticulo");
        
        const lastArticulo = articuloData[articuloData.length - 1];
        //console.log("lastArticulo", lastArticulo);
        
        if (lastArticulo.id && articuloData.length < 30 ) {
            //console.log("entra al IF");
            console.log(lastArticulo.nombre);
            
            
            setArticuloData([...articuloData, {codArticulo: "", nombre: "", ciclo: "", isbn: "", cantidad: "", precio: "", precioTotal: "" }]);
        }
    };

    const deleteArticulo = (articulo) => {
        console.log(articulo);
        
        if(articuloData.length > 1){
            const newArticulos = articuloData.filter((e) => e.id !== articulo);   
            console.log(newArticulos);
                                 
            setArticuloData(newArticulos);            
        }
    }
    
    const deleteOtrosArticulos = (articulo) => {
        console.log(articulo);
        if(articuloData.length > 1){
            const newArticulos = articuloData.filter((e) => e.id !== articulo);
            console.log(newArticulos);
                    
            setArticuloData(newArticulos);            
        }
    }

    const sumaSubtotal = () => {
        const subTotal = articuloData.reduce((acc, articulo) => acc + (parseFloat(articulo.precioTotal) || 0), 0);
        //console.log(subTotal);
        
        setSubTotal(subTotal)
    }

    const handleTotal = () => {
        const descuento = subTotal * 20 / 100;
        const total = subTotal - descuento;
        setTotal(total)
    }

    const handleCantidadArt = () => {
        const cantidadArt = articuloData.reduce((acc, articulo) => acc + (parseFloat(articulo.cantidad) || 0), 0);
        setCantidadArt(cantidadArt)
    } 

    const handleSubmit = () => {
        const filteredArticulos = articuloData.slice(0, -1); //Cortamos y eliminamos el ultimo objeto vacio

        if(clienteData.nombre === "" ||
        clienteData.ciudad === "" ||
        clienteData.direccion === "" ||
        clienteData.zona === "" ||
        clienteData.telefono === ""        
        ){
            setClienteError(true);
            return;
        } else if(articuloData.length === 1 && articuloData[0].codArticulo === ""){
            setArticuloError(true);
            return;
        }

        dispatch(postDocumento({
            numDocumento:numDocumento,
            cliente:clienteData, 
            articulos:filteredArticulos, 
            totalArt: cantidadArt,
            subtotal:subTotal, 
            total:total 
        }))

        setClienteData({});
        setArticuloData([
            {codArticulo: "", nombre:"", ciclo:"", isbn:"", cantidad:"", precio:"", precioTotal:""}            
        ])
        setSubTotal(0);
        setTotal(0);
        setCantidadArt(0);
        clienteInputRef.current.resetCliente();
        setNumDocumento(prevNum => prevNum + 1);
    }

    //////////Otros Editoriales ////////////|

    const handleOtrasEditoriales = () => {
        setOtrasEditoriales(!otrasEditoriales);
    }

    const handleClienteRegular = () => {
        setClienteRegular(!clienteRegular);
    }

    
    return (
        <>
             <div className="bg-custom container-custom">
                <div className="text-orange-500">
                <div>
                    <p className="mb-2 text-[14pt] font-semibold">Nuevo Documento</p>
                    <div className="flex">
                    <p className="mb-3 text-[14pt] font-semibold">Num. Documento: {numDocumento}</p>
                    <div className="mb-3 ml-20 w-32 border text-center text-[14pt] font-semibold">
                        {otrasEditoriales ? (<button onClick={handleOtrasEditoriales}>Mandioca</button>) : (<button onClick={handleOtrasEditoriales}>Otros</button>)}
                    </div>
                    <p className="ml-14">
                        Cliente Regular
                    </p>
                    <input 
                        type="checkbox"
                        className="ml-5 mb-4"
                        onClick={handleClienteRegular}
                    />
                    </div>                                                 
                </div>
                <div className="mb-12">
                    <ClienteInput ref={clienteInputRef} onClienteChange={handleClienteChange} clienteRegular={clienteRegular} />
                   
                </div>
                <div className="text-[10pt] font-bold border-t">
            <table>
                <thead>
                    <tr>
                        <td className="w-24 text-center border-l">Cod. Art</td>
                        <td className="w-[600px] pl-2 border-l">Articulo</td>
                        <td className="w-[120px] text-center border-l">Ciclo</td>
                        <td className="w-[135px] text-center border-l">ISBN</td>
                        <td className="w-[80px] text-center border-l">Cantidad</td>
                        <td className="w-[80px] text-center border-l">Precio Unit.</td>
                        <td className="w-[80px] text-center border-x">Precio Total</td>
                    </tr>
                </thead>                
            </table>
        </div>
            <div>
                { otrasEditoriales ? 
                 (<div>
                {articuloData && articuloData.map((articulo, index) => {
                    return (
                        <div className="flex" key={articulo.id}>
                    <ArticulosInput 
                        //key={index}              
                        index={index}
                        articuloIn={articulo}
                        onArticuloChange={(updatedArticulo) => handleArticuloChange(index, updatedArticulo)} 
                        onDelete={() => deleteArticulo(articulo.id)}
                        />
                        {/* <button onClick={() => deleteArticulo(articulo.id)}>X</button> */}
                        </div>
                )})} 
                </div>)
                :
                (
                    <div>
                        {articuloData && articuloData.map((articulo, index) => {
                    return (
                        <div className="flex" key={articulo.id}>
                            <OtrosArticulos 
                                index={index}
                                articuloIn={articulo}
                                onArticuloChange={(updatedArticulo) => handleArticuloChange(index, updatedArticulo)} 
                                onDelete={() => deleteOtrosArticulos(articulo.id)}
                            />                    
                        </div>
                )})} 
                    </div>
                )
            }
            </div> 
                <div className="font-semibold">
                    <p>Cantidad de Articulos: {cantidadArt}</p>
                    <p>Subtotal: {subTotal}</p>
                    <p>Descuento: 20%</p>
                    <p>Total: {total}</p>
                </div>
                </div>
                <div className="flex">
                    <button className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-sky-400 hover:bg-sky-100 hover:text-gray-400"
                        onClick={handleSubmit}>
                        Crear Documento
                    </button>
                    <button className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-red-500 hover:bg-red-100 hover:text-gray-400"
                        onClick={() => setVerPDF(true)}>
                        Ver PDF
                    </button>
                </div>                              
            </div>
            {/*PDF*/}
            {verPDF ? (
            <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center"
            >
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button
                  className="text-black font-bold hover:text-white"
                  onClick={() => setVerPDF(false)}
                >
                  Cerrar
                </button>
              </div>
              <div>
                <DocumentoPDF />
              </div>
            </div>
          ) : null}

            {/* Modales */}

            {artRepetido && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gray-300 font-semibold p-4 rounded">
                        <div>Articulo Repetido</div>
                        <button className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black" onClick={() => setArtRepetido(false)}>Cerrar</button>
                    </div>
                </div>
            )}            

            {clienteError && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gray-300 font-semibold p-4 rounded">
                        <div>"Nombre, Ciudad, Direccion, Zona y Telefono son campos obligatorios"</div>
                        <button className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black" onClick={() => setClienteError(false)}>Cerrar</button>
                    </div>
                </div>
            )}

            {articuloError && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gray-300 font-semibold p-4 rounded">
                        <div>"Es necesario que introduzca un articulo"</div>
                        <button className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black" onClick={() => setArticuloError(false)}>Cerrar</button>
                    </div>
                </div>
            )}
        </>        
    )
}